<template>
	<div class="ssyLogin" :class="{ 'is-modal': dialogVisible }">
		<svg
			class="ssyLogin__svg"
			viewBox="0 0 1678 937"
			preserveAspectRatio="xMidYMin slice"
			xmlns="http://www.w3.org/2000/svg"
			@click="onSvgClick"
		>
			<image
				:href="bgUrl"
				x="0"
				y="0"
				width="1678"
				height="937"
				preserveAspectRatio="xMidYMin slice"
				pointer-events="none"
			/>
			<g class="ssyLogin__hots">
				<polygon
					v-for="item in areas"
					:key="item.id"
					:points="item.points"
					class="ssyLogin__hot"
					:class="{ 'is-debug': debug }"
					@click.stop="openArea(item)"
				>
					<title>{{ item.title }}</title>
				</polygon>
			</g>
		</svg>

		<!-- 自定义弹框：背景图 dlk.png，不使用 Element Dialog -->
		<div v-if="dialogVisible" class="ssyModal">
			<div class="ssyModal__mask" @click="closeModal" />
			<div class="ssyModal__panel" :class="{ 'is-wide': steps === 2 }">
				<img class="ssyModal__bg" :src="dialogBg" alt="" />

				<div class="ssyModal__close" @click="closeModal"></div>

				<div class="login_content">
					<div v-if="showRoleSwitch && steps === 1" class="ssyModal__role">
						<button
							type="button"
							:class="{ 'is-active': role === 'teacher' }"
							@click="switchRole('teacher')"
						>教師</button>
						<button
							type="button"
							:class="{ 'is-active': role === 'student' }"
							@click="switchRole('student')"
						>學生</button>
						<button
							type="button"
							:class="{ 'is-active': role === 'classcode' }"
							@click="switchRole('classcode')"
						>課程識別碼</button>
					</div>

					<!-- 第一步：登录表单 -->
					<div v-if="steps === 1" class="ssyModal__content">
						<template v-if="role === 'teacher' || role === 'student'">
							<div class="ssyModal__fields">
								<img class="ssyModal__fieldsBg" :src="fieldsBg" alt="" />
								<input
									v-model.trim="form.account"
									class="ssyModal__input ssyModal__input--account"
									type="text"
									placeholder="請輸入登入編號"
									autocomplete="username"
									@input="inpGetAccOrgName"
								/>
								<input
									v-model="form.password"
									class="ssyModal__input ssyModal__input--password"
									type="password"
									placeholder="請輸入密碼"
									autocomplete="current-password"
									@keyup.enter="submitLogin"
								/>
							</div>
						</template>
						<template v-else>
							<div class="ssyModal__fields ssyModal__fields--code">
								<img class="ssyModal__fieldsBg" :src="codeFieldsBg" alt="" />
								<el-select
									class="ssyModal__schoolSelect"
									v-loading="Codeloading"
									filterable
									clearable
									v-model="SuffixData"
									placeholder="請選擇或搜尋學校"
								>
									<el-option
										v-for="item in CodeOptions"
										:key="item.code"
										:label="item.name"
										:value="item.code"
									>
									</el-option>
								</el-select>
								<input
									v-model.trim="form.code"
									class="ssyModal__input ssyModal__input--code"
									type="text"
									placeholder="請輸入課程識別碼"
									@keyup.enter="submitLogin"
								/>
							</div>
						</template>
					</div>

					<!-- 第二步：选择学生 -->
					<div v-else class="ssyModal__content ssyModal__content--stu">
						<div class="ssyModal__stuTip">
							<span>請選擇您的姓名</span>
							<button type="button" class="ssyModal__back" @click="backToCode">返回</button>
						</div>
						<div v-if="codeClassName" class="ssyModal__stuClass">{{ codeClassName }}</div>
						<div class="ssyModal__stuPage" :class="{ 'is-loading': nextStepsLoading }">
							<div class="ssyModal__tep">
								<div class="ssyModal__nameList">
									<div
										v-for="op in classJuri"
										:key="op.id"
										class="ssyModal__stuList"
									>
										<p class="ssyModal__stuListTit" :id="'ssy-group-' + op.id">{{ op.id }}</p>
										<div
											v-for="i in op.child"
											:key="i.userid"
											class="ssyModal__nameModule"
											:class="{ 'is-active': stuInfoCode.userid == i.userid }"
											:title="i.username"
											@click="selAcc(i)"
										>
											{{ i.username }}
										</div>
									</div>
								</div>
								<div class="ssyModal__Abar">
									<span
										v-for="op in classJuri"
										:key="'bar-' + op.id"
										@click="somp(op.id)"
									>{{ op.id }}</span>
								</div>
							</div>
							<div v-if="!classJuri.length && !nextStepsLoading" class="ssyModal__stuEmpty">此班級暫無學生</div>
						</div>
					</div>
				</div>
				<!-- 点击底图「登入」按钮区域 -->
				<button
					v-if="steps === 1"
					class="ssyModal__submit"
					type="button"
					:disabled="loading || nextStepsLoading"
					:aria-label="role === 'student' ? '確定' : '登入'"
					@click="submitLogin"
				/>
				<button
					v-else
					class="ssyModal__submit"
					type="button"
					:disabled="loading || !stuInfoCode.userid"
					aria-label="確定登入"
					@click="loginCode"
				/>

				<div v-if="loading || nextStepsLoading" class="ssyModal__loading">加載中...</div>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import qs from 'qs';
import pinyin from 'pinyin';
import { mapActions } from 'vuex';
import { API_CONFIG } from '@/common/apiConfig';
import { getUser } from '@/api/user';
import { myMixin } from '@/mixins/mixin.js';

export default {
	name: 'ssyLogin',
	mixins: [myMixin],
	props: {
		formLoginData: {
			type: Array,
			default: () => [],
		},
	},
	watch: {
		formLoginData: {
			immediate: true,
			handler(list) {
				if (!list || !list.length) return;
				this.primarySchool = (list[0] && list[0].children || []).map(item => item.schoolid);
				this.secondarySchool = (list[1] && list[1].children || []).map(item => item.schoolid);
			},
		},
	},
	data() {
		return {
			primarySchool: [],
			secondarySchool: [],
			bgUrl: require('../../assets/login/ssy01.jpg'),
			dialogBg: require('../../assets/login/dlk.png'),
			fieldsBg: require('../../assets/login/dlkzh.png'),
			codeFieldsBg: require('../../assets/login/codefrom.png'),
			debug: false,
			lastPoint: null,
			dialogVisible: false,
			activeArea: null,
			loading: false,
			nextStepsLoading: false,
			role: 'teacher',
			org: '',
			accOrgName: [],
			inpGetAccOrgNameloading: false,
			steps: 1,
			form: {
				account: '',
				password: '',
				code: '',
			},
			// 课程识别码
			icode: '',
			courseId: '',
			codeClassName: '',
			classJuri: [],
			stuInfoCode: {},
			// 学校/校区下拉
			SuffixData: '',
			CodeOptions: [],
			Codeloading: false,
			uppercaseAlphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
			redirect: this.$route.query.redirect,
			areas: [
				{
					id: 'primary',
					title: '嗇色園小學',
					en: 'Sik Sik Yuen Primary School',
					desc: '点击进入啬色园小学相关内容。',
					points: '595,374 759,342 764,395 594,428',
				},
				{
					id: 'data',
					title: '管理與數據中心',
					en: 'Management and Data Center',
					desc: '点击进入管理与数据中心相关内容。',
					points: '829,231 1067,295 1066,377 818,310',
				},
				{
					id: 'secondary',
					title: '嗇色園中學',
					en: 'Sik Sik Yuen Secondary School',
					desc: '点击进入啬色园中学相关内容。',
					points: '1137,248 1349,291 1350,355 1130,310',
				},
			],
		};
	},
	computed: {
		showRoleSwitch() {
			return !(this.activeArea && this.activeArea.id === 'data');
		},
		userRequest() {
			return this.$region == 'hk'
				? 'https://cloud.api.cocorobo.hk/api/user'
				: this.$region == 'com'
				? 'https://cloud.api.cocorobo.com/api/user'
				: 'https://beta.api.cocorobo.cn/api/user';
		},
	},
	methods: {
		...mapActions({
			login: 'user/login',
		}),
		openArea(item) {
			this.activeArea = item;
			this.role = 'teacher';
			try {
				if(item.id === 'primary') {
					this.CodeOptions = this.formLoginData[0].children;
				} else if(item.id === 'secondary') {
					this.CodeOptions = this.formLoginData[1].children;
				}
			} catch (error) {
				console.error('获取校区/学校数据失败',error);
				this.getCampusData();
			}
			this.dialogVisible = true;
		},
		closeModal() {
			this.dialogVisible = false;
			this.resetForm();
		},
		switchRole(nextRole) {
			if (this.role === nextRole) return;
			this.role = nextRole;
			// if(nextRole === 'classcode') {
			// 	this.getCampusData();
			// }
			this.onRoleChange();
		},
		onRoleChange() {
			this.clearLoginFields();
			this.steps = 1;
		},
		clearLoginFields() {
			this.form.account = '';
			this.form.password = '';
			this.form.code = '';
			this.accOrgName = [];
			this.org = '';
			this.icode = '';
			this.courseId = '';
			this.codeClassName = '';
			this.classJuri = [];
			this.stuInfoCode = {};
			this.SuffixData = '';
		},
		resetForm() {
			this.role = 'teacher';
			this.steps = 1;
			this.clearLoginFields();
			this.inpGetAccOrgNameloading = false;
			this.loading = false;
			this.nextStepsLoading = false;
		},
		// 获取校区/学校数据
		getCampusData() {
			if (this.CodeOptions.length) return;
			this.Codeloading = true;
			const params = [
				{
					functionName: API_CONFIG.select_liYuanCampus.functionName,
					org: 'aa45263b-96fc-11f1-9985-005056924926',
				},
			];

			this.$ajax
				.post(API_CONFIG.baseUrl, params)
				.then((res) => {
					this.CodeOptions = (res.data && res.data[0]) || [];
				})
				.catch((err) => {
					console.error('请求失败，错误信息：', err);
					this.CodeOptions = [];
				})
				.finally(() => {
					this.Codeloading = false;
				});
		},
		inpGetAccOrgName: _.debounce(async function () {
			// if (this.role !== 'teacher') return;

			this.accOrgName = [];
			this.org = '';

			const uname = (this.form.account || '').trim();
			if (!uname) {
				this.inpGetAccOrgNameloading = false;
				return;
			}

			this.inpGetAccOrgNameloading = true;
			const params = [
				{
					functionName: API_CONFIG.select_liYuanOrgssy.functionName,
					uname,
				},
			];

			try {
				const res = await this.$ajax.post(API_CONFIG.baseUrl, params);
				let data = (res.data && res.data[0]) || [];

				if (data.length > 0) {
					data.forEach((e) => {
						e.ou = (e.name ? e.name + ' — ' : '') + e.schoolName;
					});
					// data = data.filter((e) => e.type == 1);
				}

				this.accOrgName = data;
				this.org = this.accOrgName.length ? this.accOrgName[0].Uorg : '';
			} catch (error) {
				this.accOrgName = [];
				this.org = '';
			} finally {
				this.inpGetAccOrgNameloading = false;
			}
		}, 300),
		async submitLogin() {
			if (this.role === 'teacher' || this.role === 'student') {
				await this.loginFn();
			} else {
				await this.nextSteps();
			}
		},
		backToCode() {
			this.steps = 1;
			this.classJuri = [];
			this.stuInfoCode = {};
			this.codeClassName = '';
			this.courseId = '';
		},
		somp(val) {
			const element = document.getElementById(`ssy-group-${val}`);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		},
		// 教师账号密码登录（对应 loginPage loginFn default）
		async loginFn() {
			if (this.loading) return;
			if (this.inpGetAccOrgNameloading) {
				return this.$message.error('請等待組織識別');
			}

			const str = (this.form.account || '').replace(/(^\s*)|(\s*$)/g, '');
			const regEmail = new RegExp(
				'^[A-Za-z0-9_*-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$'
			);

			if (!str) {
				return this.$message.error('請輸入帳號');
			}
			if (!this.org) {
				return this.$message.error('請輸入完整帳號，检查输入的帳號是否正確');
			}
			if (this.form.password.length < 6) {
				return this.$message.error('密碼長度不少於6位');
			}
			// 僅允許字母、數字、可見符號（ASCII），不可含中文等
			if (!/^[\x21-\x7E]+$/.test(this.form.password)) {
				return this.$message.error('密碼只能為字母、數字或符號');
			}

			this.loading = true;
			const orgValue = this.org ? '@' + this.org : '@cocorobo.cc';
			const email = regEmail.test(str) ? str : str + orgValue;

			let params = {};
			try {
				params = {
					geetest_challenge: '',
					geetest_validate: '',
					geetest_seccode: '',
					loginUsername: email.trim(),
					loginPassword: window.btoa(this.form.password.trim()),
				};
			} catch (e) {
				this.loading = false;
				return this.$message.error('密碼只能為字母、數字或符號');
			}

			axios.defaults.withCredentials = true;
			try {
				const res = await axios.post(this.userRequest, qs.stringify(params));
				const _data = res.data[0][0];
				const userjson = await getUser({ userid: _data.userid });
				const currentDate = new Date();
				const u = userjson.data[0][0];
				console.log('u',u);
				if (!this.showRoleSwitch && u.role != 1 && u.rrole != 1) return this.$message.error('請使用集团管理員帳號登入');

				if (this.activeArea.id === 'primary' && this.primarySchool.length && !this.primarySchool.includes(u.organizeid) && u.organizeid != 'e6bdf92f-9784-11f1-9985-005056924926') {
					return this.$message.error('請使用啬色園小學帳號登入');
				}
				if (this.activeArea.id === 'secondary' && this.secondarySchool.length && !this.secondarySchool.includes(u.organizeid) && u.organizeid != 'e6bdf92f-9784-11f1-9985-005056924926') {
					return this.$message.error('請使用啬色園中學帳號登入');
				}
				if (this.role == 'teacher' && u.type != 1) return this.$message.error('請使用教師帳號登入');
				if (this.role == 'student' && u.type != 2) return this.$message.error('請使用學生帳號登入');

				if (
					u.isLogin1 == 2 ||
					(u.isLogin1 && u.isLogin1 != 1 && u.isLogin1 != 2 && new Date(u.isLogin1) < currentDate) ||
					u.isLogin2 == 2 ||
					(u.isLogin2 != 1 && u.isLogin2 != 2 && new Date(u.isLogin2) < currentDate) ||
					u.state != 1
				) {
					this.loading = false;
					return this.$message.error('帳號狀態異常，請聯繫管理員');
				}

				if (_data.active === 1) {
					window.localStorage['identity'] = JSON.stringify(_data.identity);
					window.topU.U.UF.Cookie.set('cocoroboLoginType=2');
					window.topU
						? (window.topU.US.userInfo = _data)
						: (window.parent.US.userInfo = _data);
					await this.login();
					this.$message.success('登入成功');
					window.sessionStorage.removeItem('stuInfoCode');
					this.dialogVisible = false;
					if (
						u.type == 1 &&
						u.role == 1 &&
						u.rrole == 1
					) {
						this.$router.push({ path: '/kanban' });
					} else {
						this.$router.push({ path: this.redirect || '/' });
					}
					this.addOp3(
						'1',
						'',
						{ type: this.prefixL + (u.type == 1 ? '_teacher' : '_student') + 'login' },
						'success',
						_data.userid
					);
				} else {
					this.$message.error('登入失敗');
				}
			} catch (e) {
				if (
					e.response &&
					(e.response.data == 'Wrong email or password' ||
						e.response.data == '错误邮箱和密码')
				) {
					this.$message.error('帳號或密碼錯誤');
				} else {
					this.$message.error('登入失敗');
				}
			} finally {
				this.loading = false;
			}
		},
		// 学生识别码登录：查课程 → 选班级学生（对应 loginPage nextSteps）
		async nextSteps() {
			if (!this.SuffixData) {
				return this.$message.error('請選擇學校');
			}
			const code = (this.form.code || '').trim();
			if (!code) {
				return this.$message.error('請輸入課程識別碼');
			}
			if (!/^\d+$/.test(code)) {
				return this.$message.error('請正確填寫課程識別碼');
			}

			// 课程识别码
			this.icode = code;
			// 加载中
			this.nextStepsLoading = true;
			// 学生信息
			this.stuInfoCode = {};
			// 班级列表
			this.classJuri = [];

			const params = [
				{
					functionName: API_CONFIG.ajax_selectCourseByIc2.functionName,
					code,
					oid: this.SuffixData,
				},
			];

			try {
				const res = await this.$ajax.post(API_CONFIG.baseUrl, params);
				if (res.data.length && res.data[0].length) {
					this.courseId = res.data[0][0].courseId;
					const organizeid = res.data[0][0].organizeid;
					// 班级名称
					await this.getClassName(res.data[0][0].classid);
					// 班级列表
					await this.getClass(res.data[0][0].classid, organizeid);
				} else {
					this.$message.error('不存在此課程識別碼');
				}
			} catch (err) {
				console.error(err);
				this.$message.error('不存在此課程識別碼');
			} finally {
				this.nextStepsLoading = false;
			}
		},
		// 获取班级名称
		getClassName(val) {
			const params = [
				{
					functionName: API_CONFIG.ajax_selectliyuanCodename.functionName,
					cid: val,
				},
			];
			return this.$ajax
				.post(API_CONFIG.baseUrl, params)
				.then((res) => {
					this.codeClassName = res.data[0][0].name;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		// 获取班级列表
		getClass(classId, oid) {
			const params = [
				{
					functionName: API_CONFIG.ajax_selectSnameByCidAndOid.functionName,
					cid: classId,
					oid,
				},
			];
			return this.$ajax
				.post(API_CONFIG.baseUrl, params)
				.then((res) => {
					this.classJuri = this.groupByName(res.data[0] || []);
					this.steps = 2;
				})
				.catch((err) => {
					console.error(err);
					this.$message.error('此班級暫無學生');
				});
		},
		// 按拼音分组
		groupByName(list) {
			let alphabetArray = Array.from({ length: 26 }, (_, i) => ({
				id: String.fromCharCode(65 + i),
				child: [],
			}));
			alphabetArray.push({ id: '#', child: [] });

			list.forEach((e) => {
				const l = pinyin(e.username, { style: pinyin.STYLE_NORMAL })
					.join('')[0]
					.toLocaleUpperCase();
				if (this.uppercaseAlphabet.includes(l)) {
					alphabetArray.forEach((k) => {
						if (l == k.id) k.child.push(e);
					});
				} else {
					alphabetArray[alphabetArray.length - 1].child.push(e);
				}
			});

			return alphabetArray.filter((e) => e.child.length);
		},
		// 选择学生
		selAcc(val) {
			this.stuInfoCode = val;
		},
		// 学生选人后登录（对应 loginPage loginCode）
		async loginCode() {
			if (!this.stuInfoCode.userid) {
				return this.$message.error('請選擇您的姓名');
			}
			try {
				await this.$confirm(
					`確定登入${this.stuInfoCode.username}的帳號嗎?`,
					'提示',
					{
						confirmButtonText: '確定',
						cancelButtonText: '取消',
						type: 'warning',
					}
				);
			} catch (e) {
				return;
			}

			this.loading = true;
			const params = {
				geetest_challenge: '',
				geetest_validate: '',
				geetest_seccode: '',
				openid: this.stuInfoCode.userid,
				edu: true,
			};
			axios.defaults.withCredentials = true;

			try {
				const res = await axios.post(this.userRequest, qs.stringify(params));
				const _data = res.data[0][0];
				const userjson = await getUser({ userid: _data.userid });
				const currentDate = new Date();
				const u = userjson.data[0][0];

				if (
					u.isLogin1 == 2 ||
					(u.isLogin1 && u.isLogin1 != 1 && u.isLogin1 != 2 && new Date(u.isLogin1) < currentDate) ||
					u.isLogin2 == 2 ||
					(u.isLogin2 != 1 && u.isLogin2 != 2 && new Date(u.isLogin2) < currentDate) ||
					u.state != 1
				) {
					return this.$message.error('帳號狀態異常，請聯繫管理員');
				}

				if (_data.active === 1) {
					window.localStorage['identity'] = JSON.stringify(_data.identity);
					window.topU.U.UF.Cookie.set('cocoroboLoginType=2');
					window.topU
						? (window.topU.US.userInfo = _data)
						: (window.parent.US.userInfo = _data);
					await this.login();
					this.$message.success('登入成功');
					// 浏览器缓存添加随机码登录信息
					window.sessionStorage.setItem('stuInfoCode', JSON.stringify(this.icode));
					// 关闭弹窗
					this.dialogVisible = false;
					// 跳转课程页面
					this.$router.push({
						path: this.redirect || '/',
						query: { courseid: this.courseId },
					});
					this.addOp3(
						'1',
						'',
						{ type: this.prefixL + 'stuCode_login' },
						'success',
						this.stuInfoCode.userid
					);
				} else {
					this.$message.error('登入失敗');
				}
			} catch (err) {
				console.error(err);
				this.$message.error('登入失敗');
			} finally {
				this.loading = false;
			}
		},
		// 点击热点
		onSvgClick(e) {
			if (!this.debug) return;
			const svg = e.currentTarget;
			const pt = svg.createSVGPoint();
			pt.x = e.clientX;
			pt.y = e.clientY;
			const cursor = pt.matrixTransform(svg.getScreenCTM().inverse());
			this.lastPoint = {
				x: Math.round(cursor.x),
				y: Math.round(cursor.y),
			};
			console.log('[ssy hotspot]', this.lastPoint);
		},
	},
};
</script>

<style scoped>
.ssyLogin {
	position: relative;
	width: 100vw;
	height: 100vh;
	overflow: hidden;
	background: #0b1c2c;
}

.ssyLogin__svg {
	display: block;
	width: 100%;
	height: 100%;
	min-width: 100%;
	min-height: 100%;
	transition: filter 0.25s ease;
}

.ssyLogin.is-modal .ssyLogin__svg {
	filter: blur(5px) brightness(0.92);
}

.ssyLogin__hot {
	fill: transparent;
	cursor: pointer;
}

.ssyLogin__hot.is-debug {
	fill: rgba(255, 80, 80, 0.28);
	stroke: #ff5050;
	stroke-width: 2;
}

.ssyModal {
	position: absolute;
	inset: 0;
	z-index: 20;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
}

.ssyModal__mask {
	position: absolute;
	inset: 0;
	background: rgba(10, 30, 60, 0.2);
}

.ssyModal__panel {
	position: relative;
	z-index: 1;
	width: 420px;
}

/* .ssyModal__panel.is-wide {
	width: min(520px, 94vw);
} */

.ssyModal__bg {
	display: block;
	height: auto;
	max-width: 420px;
	pointer-events: none;
	user-select: none;
}

.ssyModal__close {
	position: absolute;
	top: 9%;
	right: 8.5%;
	/* background: #fff; */
	width: 38px;
	height: 40px;
	cursor: pointer;
	z-index: 3;
}

.ssyModal__role {
	display: flex;
	z-index: 2;
	gap: 8px;
}

.ssyModal__role button {
	min-width: 64px;
	height: 28px;
	padding: 0 12px;
	border: 2px solid rgba(255, 255, 255, 0.25);
	border-radius: 999px;
	background: #fff;
	color: #180c0c;
	font-size: 13px;
	font-weight: 700;
	cursor: pointer;
}

.ssyModal__role button.is-active {
	background: #fff;
	color: #2f8fff;
	border-color: #fff;
}

.ssyModal__content {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.ssyModal__content--stu {
	justify-content: flex-start;
	padding: 4px 2px 0;
	width: 80%;
	box-sizing: border-box;
	overflow: hidden;
}

.ssyModal__fields {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}

.ssyModal__fieldsBg {
	display: block;
	width: 80%;
	height: auto;
	pointer-events: none;
	user-select: none;
}

.ssyModal__input {
	position: absolute;
	left: 26%;
	height: 20%;
	width: 55%;
	border: 0;
	outline: none;
	background: transparent;
	color: #333;
	font-size: 15px;
	box-sizing: border-box;
}

.ssyModal__input::placeholder {
	color: #b0b8c4;
}

.ssyModal__input--account {
	top: 20%;
}

.ssyModal__input--password {
	top: 69%;
}

.ssyModal__fields--code .ssyModal__schoolSelect {
	position: absolute;
	left: 28%;
	top: 16%;
	width: 55%;
	height: 28%;
	z-index: 3;
}

.ssyModal__fields--code .ssyModal__schoolSelect >>> .el-input,
.ssyModal__fields--code .ssyModal__schoolSelect >>> .el-input__inner {
	height: 100%;
	border: 0;
	outline: none;
	background: transparent;
	box-shadow: none;
	color: #333;
	font-size: 15px;
	padding-left: 0;
}

.ssyModal__fields--code .ssyModal__schoolSelect >>> .el-input__inner::placeholder {
	color: #b0b8c4;
}

.ssyModal__fields--code .ssyModal__schoolSelect >>> .el-input__suffix {
	display: flex;
	align-items: center;
}

.ssyModal__fields--code .ssyModal__input--code {
	left: 28%;
	top: 60%;
	height: 36%;
}

.ssyModal__submit {
	position: absolute;
	left: 26%;
	right: 26%;
	top: 78%;
	height: 10%;
	padding: 0;
	border: 0;
	background: transparent;
	cursor: pointer;
	z-index: 3;
}

.ssyModal__submit:disabled {
	cursor: not-allowed;
}

.ssyModal__loading {
	position: absolute;
	left: 50%;
	bottom: 4%;
	transform: translateX(-50%);
	z-index: 4;
	padding: 4px 12px;
	border-radius: 999px;
	background: rgba(0, 0, 0, 0.55);
	color: #fff;
	font-size: 12px;
	pointer-events: none;
}

.ssyModal__back {
	align-self: flex-start;
	margin-bottom: 4px;
	padding: 0;
	border: 0;
	background: transparent;
	color: #2f6fbe;
	font-size: 13px;
	font-weight: 700;
	cursor: pointer;
}

.ssyModal__stuTip {
	display: flex;
	justify-content: space-between;
	font-size: 15px;
	font-weight: 700;
	color: #222;
}

.ssyModal__stuClass {
	margin: 2px 0 6px;
	font-size: 12px;
	color: #888;
}

.ssyModal__stuPage {
	flex: 1;
	min-height: 0;
	position: relative;
}

.ssyModal__stuPage.is-loading::after {
	content: '加載中...';
	position: absolute;
	inset: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.65);
	color: #666;
	font-size: 13px;
}

.ssyModal__tep {
	display: flex;
	gap: 6px;
	height: 100%;
	max-height: 220px;
}

.ssyModal__nameList {
	flex: 1;
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 28px;
	padding-top: 22px;
	box-sizing: border-box;
}

.ssyModal__nameList::-webkit-scrollbar {
	width: 0;
}

.ssyModal__stuList {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 8px;
	position: relative;
}
.login_content {
	/* background: #cb8d8d; */
	position: absolute;
	height: 45%;
	width: 100%;
	top: 30%;
	padding: 2px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	box-sizing: border-box;
	align-items: center;
}
.ssyModal__stuListTit {
	position: absolute;
	top: -22px;
	left: 0;
	width: 100%;
	padding: 1px 4px;
	box-sizing: border-box;
	background: #f5faff;
	font-size: 12px;
	font-weight: 600;
	color: #666;
}

.ssyModal__nameModule {
	padding: 3px 6px;
	border: 1px solid #e7e7e7;
	border-radius: 3px;
	text-align: center;
	cursor: pointer;
	line-height: 20px;
	font-size: 12px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: #333;
	background: #fff;
}

.ssyModal__nameModule.is-active {
	background: #006afe;
	border-color: #006afe;
	color: #fff;
}

.ssyModal__Abar {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1px;
	padding: 2px 0;
	font-size: 11px;
	color: #666;
	user-select: none;
}

.ssyModal__Abar span {
	cursor: pointer;
	line-height: 1.15;
}

.ssyModal__Abar span:hover {
	color: #006afe;
}

.ssyModal__stuEmpty {
	padding: 20px 0;
	text-align: center;
	color: #999;
	font-size: 13px;
}

@media (max-width: 480px) {
	.ssyModal__input {
		font-size: 13px;
	}

	.ssyModal__stuList {
		grid-template-columns: repeat(2, 1fr);
	}
}
</style>
